/**
 * File type configurations for uploads
 */

// Allowed file types for different upload scenarios
export const FILE_TYPES = {
  CERTIFICATE: [
    "application/pdf",
    // "image/jpeg",
    // "image/png",
  ],
  FELLOWSHIP: [
    "application/pdf",
    // "application/msword",
    // "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
  IMAGE: [
    "image/jpeg",
    "image/png",
  ],
  DOCUMENT: [
    "application/pdf",
  ],
};

// Maximum file size limits (in MB)
export const FILE_SIZE_LIMITS = {
  CERTIFICATE: 5,
  FELLOWSHIP: 10,
  IMAGE: 2,
  DOCUMENT: 5,
  DEFAULT: 5,
};

// Human-readable file type descriptions
export const FILE_TYPE_LABELS = {
  CERTIFICATE: "PDF, JPG, or PNG",
  FELLOWSHIP: "PDF or Word Document",
  IMAGE: "JPG or PNG",
  DOCUMENT: "PDF",
};
